import AuthConfig from '../../services/auth/AuthConfig';
import { FeatureFlags } from './FeatureFlags';

export class AppSettings {
  auth: AuthConfig = new AuthConfig();
  apiUrl: string = '';
  recaptchaSiteKey: string = '';
  featureFlags: FeatureFlags = new FeatureFlags();
}
